import React from 'react'
import {map} from 'lodash'
import {switchToSlide} from './SlideHelper'
import {Image, Col, Row} from 'react-bootstrap'

const SliderThumbnail = ({photos, slider}) => {
  const changeSlide = (index) => {
    if (slider.getActiveIndex() !== index) {
      switchToSlide(slider, photos.length, index)
    }
  }

  return (
    <Row>
      {map(photos, (photo, index) => {
        return (
          <Col xs={6} sm={6} md={4} key={index} >
            <Image src={photo.url.thumb} width={40} onClick={() => changeSlide(index)} />
          </Col>
        )
      })}
    </Row>
  )
}

SliderThumbnail.propTypes = {
  photos: React.PropTypes.array.isRequired,
  slider: React.PropTypes.object.isRequired
}

export default SliderThumbnail



// WEBPACK FOOTER //
// ./src/components/NewHorse/Slider/SliderThumbnail.js